<template>
  <img
    width="100%"
    height="100%"
    :src="getImage" />

</template>

<script>
export default {
  props: {

    // Determines witch pack of images to use...
    pack: {
      required: true,
      default: 'clear'
    },

    // Determines what image from that pack to use...
    name: {
      required: true,
      default: ''
    }
  },
  computed: {
    getImage () {
      return ((this.$store.getters.qlogos || {})[this.pack] || {})[this.name]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/standard/display/QImage.vue?23e451ae